import Vue from "vue";
import Router from "vue-router";
import AuthService from "../service/AuthService";
import MethodService from "../service/MethodService";
import LanguageService from "../service/LanguageService";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const DefaultContainerClient = () =>
  import("@/containers/DefaultContainerClient");

// Views - admin
const AdminDashboard = () => import("@/views/admin/Dashboard/Dashboard");

// const AdminUserList = () => import('@/views/admin/User/UserList');
// const AdminUserForm = () => import('@/views/admin/User/UserForm');

const AdminTourList = () => import("@/views/admin/Tour/TourList");
const AdminTourForm = () => import("@/views/admin/Tour/TourForm");

const AdminCongTyLuHanhList = () =>
  import("@/views/admin/CongTyLuHanh/CongTyLuHanhList");
const AdminCongTyLuHanhForm = () =>
  import("@/views/admin/CongTyLuHanh/CongTyLuHanhForm");

const AdminNhomPhanHoiList = () =>
  import("@/views/admin/NhomPhanHoi/NhomPhanHoiList");
const AdminNhomPhanHoiForm = () =>
  import("@/views/admin/NhomPhanHoi/NhomPhanHoiForm");

const AdminPhanHoiList = () => import("@/views/admin/PhanHoi/PhanHoiList");
const AdminPhanHoiForm = () => import("@/views/admin/PhanHoi/PhanHoiForm");
const AdminPhanHoiTcqlttForm = () =>
  import("@/views/admin/PhanHoi/PhanHoiTcqlttForm");

const AdminPhieuDieuTourList = () =>
  import("@/views/admin/PhieuDieuTour/PhieuDieuTourList");
const AdminPhieuDieuTourForm = () =>
  import("@/views/admin/PhieuDieuTour/PhieuDieuTourForm");

const AdminHuongDanVienList = () =>
  import("@/views/admin/HuongDanVien/HuongDanVienList");
const AdminHuongDanVienDaDanList = () =>
  import("@/views/admin/HuongDanVien/HuongDanVienDaDanList");
const AdminHuongDanVienForm = () =>
  import("@/views/admin/HuongDanVien/HuongDanVienForm");
const AdminHuongDanVienDaDanForm = () =>
  import("@/views/admin/HuongDanVien/HuongDanVienDaDanForm");

const AdminKhachDuLichList = () =>
  import("@/views/admin/KhachDuLich/KhachDuLichList");
const AdminKhachDuLichForm = () =>
  import("@/views/admin/KhachDuLich/KhachDuLichForm");

const AdminTinTucList = () => import("@/views/admin/TinTuc/TinTucList");
const AdminTinTucForm = () => import("@/views/admin/TinTuc/TinTucForm");

const AdminDichVuChatLuongCaoList = () =>
  import("@/views/admin/DichVuChatLuongCao/DichVuChatLuongCaoList");
const AdminDichVuChatLuongCaoForm = () =>
  import("@/views/admin/DichVuChatLuongCao/DichVuChatLuongCaoForm");

const AdminDanhGiaList = () => import("@/views/admin/DanhGia/DanhGiaList");
const AdminDanhGiaForm = () => import("@/views/admin/DanhGia/DanhGiaForm");

const AdminThongBaoList = () => import("@/views/admin/ThongBao/ThongBaoList");
const AdminThongBaoForm = () => import("@/views/admin/ThongBao/ThongBaoForm");

const AdminCoSoLuuTruList = () =>
  import("@/views/admin/CoSoLuuTru/CoSoLuuTruList");
const AdminCoSoLuuTruForm = () =>
  import("@/views/admin/CoSoLuuTru/CoSoLuuTruForm");

const AdminCanhBaoHangNgayList = () =>
  import("@/views/admin/CanhBaoHangNgay/CanhBaoHangNgayList");
const AdminCanhBaoHangNgayForm = () =>
  import("@/views/admin/CanhBaoHangNgay/CanhBaoHangNgayForm");

const AdminChuongTrinhList = () =>
  import("@/views/admin/ChuongTrinh/ChuongTrinhList");
const AdminChuongTrinhForm = () =>
  import("@/views/admin/ChuongTrinh/ChuongTrinhForm");

const AdminDangKyChuongTrinhList = () =>
  import("@/views/admin/DangKyChuongTrinh/DangKyChuongTrinhList");
const AdminDangKyChuongTrinhForm = () =>
  import("@/views/admin/DangKyChuongTrinh/DangKyChuongTrinhForm");
const AdminDangKyChuongTrinhListSuccess = () =>
  import("@/views/admin/DangKyChuongTrinh/DangKyChuongTrinhListSuccess");

const AdminThanhTichHuyHieuList = () =>
  import("@/views/admin/ThanhTichHuyHieu/ThanhTichHuyHieuList");
const AdminThanhTichHuyHieuForm = () =>
  import("@/views/admin/ThanhTichHuyHieu/ThanhTichHuyHieuForm");

const AdminMsKhachDuLichList = () =>
  import("@/views/admin/MsKhachDuLich/MsKhachDuLichList");
const AdminMsKhachDuLichForm = () =>
  import("@/views/admin/MsKhachDuLich/MsKhachDuLichForm");
const AdminMsKhachDuLichRegister = () =>
  import("@/views/admin/MsKhachDuLich/MsKhachDuLichRegister");

const AdminPhienBanList = () => import("@/views/admin/PhienBan/PhienBanList");
const AdminPhienBanForm = () => import("@/views/admin/PhienBan/PhienBanForm");

const AdminNhomTPDanhGiaList = () =>
  import("@/views/admin/NhomTPDanhGia/NhomTPDanhGiaList");
const AdminNhomTPDanhGiaForm = () =>
  import("@/views/admin/NhomTPDanhGia/NhomTPDanhGiaForm");

const AdminQuocTichList = () => import("@/views/admin/QuocTich/QuocTichList");
const AdminQuocTichForm = () => import("@/views/admin/QuocTich/QuocTichForm");

const AdminDanhMucTinTucList = () =>
  import("@/views/admin/DanhMucTinTuc/DanhMucTinTucList");
const AdminDanhMucTinTucForm = () =>
  import("@/views/admin/DanhMucTinTuc/DanhMucTinTucForm");

const AdminNgoaiNguList = () => import("@/views/admin/NgoaiNgu/NgoaiNguList");
const AdminNgoaiNguForm = () => import("@/views/admin/NgoaiNgu/NgoaiNguForm");

const AdminSoTruongList = () => import("@/views/admin/SoTruong/SoTruongList");
const AdminSoTruongForm = () => import("@/views/admin/SoTruong/SoTruongForm");

const AdminHuyHieuList = () => import("@/views/admin/HuyHieu/HuyHieuList");
const AdminHuyHieuForm = () => import("@/views/admin/HuyHieu/HuyHieuForm");

const AdminCauHinhList = () => import("@/views/admin/CauHinh/CauHinhList");
const AdminCauHinhForm = () => import("@/views/admin/CauHinh/CauHinhForm");

const AdminNguoiDungList = () =>
  import("@/views/admin/NguoiDung/NguoiDungList");
const AdminNguoiDungForm = () =>
  import("@/views/admin/NguoiDung/NguoiDungForm");

const AdminNguoiDungTcqlttList = () =>
  import("@/views/admin/NguoiDungTcqltt/NguoiDungTcqlttList");
const AdminNguoiDungTcqlttForm = () =>
  import("@/views/admin/NguoiDungTcqltt/NguoiDungTcqlttForm");

const AdminDangKyDDATList = () =>
  import("@/views/admin/DangKyDDAT/DangKyDDATList");
const AdminDangKyDDATForm = () =>
  import("@/views/admin/DangKyDDAT/DangKyDDATForm");
const AdminDangKyDDATListSuccess = () =>
  import("@/views/admin/DangKyDDAT/DangKyDDATListSuccess");

const AdminDiemDenAnToanList = () =>
  import("@/views/admin/DiemDenAnToan/DiemDenAnToanList");
const AdminDiemDenAnToanForm = () =>
  import("@/views/admin/DiemDenAnToan/DiemDenAnToanForm");
const AdminDiemDenAnToanImport = () =>
  import("@/views/admin/DiemDenAnToan/DiemDenAnToanImport");
const AdminDiemDenAnToanUpdateSuccess = () =>
  import("@/views/admin/DiemDenAnToan/DiemDenAnToanUpdateSuccess");
const AdminDiemDenAnToanSurveyForm = () =>
  import("@/views/admin/DiemDenAnToan/DiemDenAnToanSurveyForm");

const AdminCheckinDDATList = () =>
  import("@/views/admin/CheckinDDAT/CheckinDDATList");
const AdminCheckinDDATForm = () =>
  import("@/views/admin/CheckinDDAT/CheckinDDATForm");

// const AdminVungDichList = () => import("@/views/admin/VungDich/VungDichList");
// const AdminVungDichForm = () => import("@/views/admin/VungDich/VungDichForm");

const AdminDanhGiaKDLList = () =>
  import("@/views/admin/DanhGiaKDL/DanhGiaKDLList");
const AdminDanhGiaKDLForm = () =>
  import("@/views/admin/DanhGiaKDL/DanhGiaKDLForm");
const AdminDanhGiaDDATList = () =>
  import("@/views/admin/DanhGiaDDAT/DanhGiaDDATList");
const AdminDanhGiaDDATForm = () =>
  import("@/views/admin/DanhGiaDDAT/DanhGiaDDATForm");

// const DanhGiaDDATHangNgay = () => import("@/views/admin/DanhGiaDDATHangNgay/DanhGiaDDATHangNgay");
const LichBieuKBAT = () => import("@/views/admin/LichBieuKBAT/LichBieuKBAT");

const AdminDanhGiaDDATDetailList = () =>
  import("@/views/admin/DanhGiaDDATDetail/DanhGiaDDATDetailList");
const AdminDanhGiaDDATDetailForm = () =>
  import("@/views/admin/DanhGiaDDATDetail/DanhGiaDDATDetailForm");

const AdminDanhGiaKDLDetailList = () =>
  import("@/views/admin/DanhGiaKDLDetail/DanhGiaKDLDetailList");
const AdminDanhGiaKDLDetailForm = () =>
  import("@/views/admin/DanhGiaKDLDetail/DanhGiaKDLDetailForm");

const AdminTruyVanSMSForm = () =>
  import("@/views/admin/TruyVanSMS/TruyVanSMSForm");

const AdminQuangCaoList = () =>
  import("@/views/admin/QuangCao/QuangCaoList");
const AdminQuangCaoForm = () =>
  import("@/views/admin/QuangCao/QuangCaoForm");

const AdminQuanLyMerchantList = () => import("@/views/admin/QuanLyMerchant/QuanLyMerchantList");
const AdminQuanLyMerchantForm = () => import("@/views/admin/QuanLyMerchant/QuanLyMerchantForm");
const MerchantTest = () => import("@/views/admin/MerchantTest/MerchantTest");

const AdminLienKetNganHangSHBList = () => import("@/views/admin/LienKetNganHangSHB/LienKetNganHangSHBList");
const AdminLienKetNganHangSHBForm = () => import("@/views/admin/LienKetNganHangSHB/LienKetNganHangSHBForm");
const AdminLienKetNganHangSHBChuaLienKetList = () => import("@/views/admin/LienKetNganHangSHB/LienKetNganHangSHBChuaLienKetList");

const AdminHDSD = () => import("@/views/admin/HDSD/HDSD");
const TrangDieuHanh = () => import("@/views/admin/TrangDieuHanh/TrangDieuHanh");

// Views - auth
const AuthPage404 = () => import("@/views/auth/Page404");
const AuthLogin = () => import("@/views/auth/Login");
const AuthRegister = () => import("@/views/auth/Register");
const AuthRegisterSafePlaceUser = () =>
  import("@/views/auth/RegisterSafePlaceUser");
const AuthChangePassword = () => import("@/views/auth/ChangePassword");

const AuthForgotPassword = () => import("@/views/auth/ForgotPassword");
const AuthResetPassword = () => import("@/views/auth/ResetPassword");

// Views - client
// const ClientHome = () => import("@/views/client/Home");
const ClientDashboard = () => import("@/views/client/Dashboard");
const Croper = () => import("@/views/admin/ImageCroper/Image");

Vue.use(Router);
/* Các quyền người dùng: BuiltinAdmin - Tài khoản super admin, Admin - Quản trị hệ thống, Officer - Quản lý nhà nước, TourGuide - Hướng dẫn viên du lịch, TourAgent - Công ty lữ hành, User - người dùng */
//ex roles: ["BuiltinAdmin ", "Admin", "TourGuide", "TourAgent", "User"]

const router = new Router({
  base: window.MyConfig.pathDefault,
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: "/",
      redirect: window.MyConfig.defaultRouter,
      component: DefaultContainerClient
    },
    // {
    //   path: '/home',
    //   name: 'Client-Home',
    //   component: ClientHome,
    //   meta: {
    //     allowAccess: ['*'],
    //     page: 'client'
    //   },
    // },
    {
      path: "/admin",
      redirect: "/admin/home",
      component: DefaultContainer,
      children: [
        {
          path: "Croper",
          name: "Admin-Croper",
          component: Croper,
          meta: {
            allowAccess: ["*"],
            page: "admin"
          }
        },
        {
          path: "home",
          name: "Admin-Home",
          component: AdminDashboard,
          meta: {
            allowAccess: ["*"],
            page: "admin"
          }
        },
        {
          path: "DuLieuAnToanHangNgay",
          name: "Admin-LichBieuKBAT",
          component: LichBieuKBAT,
          meta: {
            allowAccess: ["SafePlace"],
            page: "admin"
          }
        },
        // {
        //   path: 'User',
        //   name: 'Admin-User',
        //   redirect: '/admin/User/list',
        //   component: {
        //     render(c) {
        //       return c('router-view')
        //     }
        //   },
        //   children: [{
        //     path: 'list',
        //     name: 'Admin-User-list',
        //     component: AdminUserList,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   {
        //     path: 'create',
        //     name: 'Admin-User-create',
        //     component: AdminUserForm,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   {
        //     path: 'update/:id',
        //     name: 'Admin-User-update',
        //     component: AdminUserForm,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   {
        //     path: 'detail/:id',
        //     name: 'Admin-User-detail',
        //     component: AdminUserForm,
        //     meta: {
        //       allowAccess: ['*'],
        //       page: 'admin'
        //     },
        //   },
        //   ]
        // },
        {
          path: "Tour",
          name: "Admin-Tour",
          redirect: "/admin/Tour/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-Tour-list",
              component: AdminTourList,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-Tour-create",
              component: AdminTourForm,
              meta: {
                allowAccess: ["BuiltinAdmin", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-Tour-update",
              component: AdminTourForm,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-Tour-detail",
              component: AdminTourForm,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "CongTyLuHanh",
          name: "Admin-CongTyLuHanh",
          redirect: "/admin/CongTyLuHanh/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CongTyLuHanh-list",
              component: AdminCongTyLuHanhList,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-CongTyLuHanh-create",
              component: AdminCongTyLuHanhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-CongTyLuHanh-update",
              component: AdminCongTyLuHanhForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-CongTyLuHanh-detail",
              component: AdminCongTyLuHanhForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "PhanHoi",
          name: "Admin-PhanHoi",
          redirect: "/admin/PhanHoi/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-PhanHoi-list",
              component: AdminPhanHoiList,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TCQLTT",
                  "VNATAdmin",
                  "SVHTT",
                  "PVHTT"
                ],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-PhanHoi-create",
              component: AdminPhanHoiForm,
              meta: {
                allowAccess: ["BuiltinAdmin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-PhanHoi-update",
              component: AdminPhanHoiForm,
              meta: {
                allowAccess: ["Officer", "TourAgent", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-PhanHoi-detail",
              component: AdminPhanHoiForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TCQLTT",
                  "VNATAdmin",
                  "SVHTT",
                  "PVHTT"
                ],
                page: "admin"
              }
            },
            {
              path: "updateTcqltt/:id",
              name: "Admin-PhanHoi-updateTcqltt",
              component: AdminPhanHoiTcqlttForm,
              meta: {
                allowAccess: ["TCQLTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "PhieuDieuTour",
          name: "Admin-PhieuDieuTour",
          redirect: "/admin/PhieuDieuTour/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-PhieuDieuTour-list",
              component: AdminPhieuDieuTourList,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-PhieuDieuTour-create",
              component: AdminPhieuDieuTourForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-PhieuDieuTour-update",
              component: AdminPhieuDieuTourForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-PhieuDieuTour-detail",
              component: AdminPhieuDieuTourForm,
              meta: {
                allowAccess: ["Admin", "TourAgent"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "HuongDanVien",
          name: "Admin-HuongDanVien",
          redirect: "/admin/HuongDanVien/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-HuongDanVien-list",
              component: AdminHuongDanVienList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-HuongDanVien-create",
              component: AdminHuongDanVienForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-HuongDanVien-update",
              component: AdminHuongDanVienForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-HuongDanVien-detail",
              component: AdminHuongDanVienForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "HuongDanVienDaDan",
          name: "Admin-HuongDanVienDaDan",
          redirect: "/admin/HuongDanVienDaDan/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-HuongDanVienDaDan-list",
              component: AdminHuongDanVienDaDanList,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-HuongDanVienDaDan-detail",
              component: AdminHuongDanVienDaDanForm,
              meta: {
                allowAccess: ["TourAgent"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "KhachDuLich",
          name: "Admin-KhachDuLich",
          redirect: "/admin/KhachDuLich/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-KhachDuLich-list",
              component: AdminKhachDuLichList,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent", "TourGuide"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-KhachDuLich-create",
              component: AdminKhachDuLichForm,
              meta: {
                allowAccess: ["BuiltinAdmin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-KhachDuLich-update",
              component: AdminKhachDuLichForm,
              meta: {
                allowAccess: ["User"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-KhachDuLich-detail",
              component: AdminKhachDuLichForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent", "TourGuide"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "TinTuc",
          name: "Admin-TinTuc",
          redirect: "/admin/TinTuc/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-TinTuc-list",
              component: AdminTinTucList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-TinTuc-create",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-TinTuc-update",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-TinTuc-detail",
              component: AdminTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DichVuChatLuongCao",
          name: "Admin-DichVuChatLuongCao",
          redirect: "/admin/DichVuChatLuongCao/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DichVuChatLuongCao-list",
              component: AdminDichVuChatLuongCaoList,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "HqsManager",
                  "HqsContributor"
                ],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DichVuChatLuongCao-create",
              component: AdminDichVuChatLuongCaoForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "HqsManager",
                  "HqsContributor"
                ],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DichVuChatLuongCao-update",
              component: AdminDichVuChatLuongCaoForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "HqsManager",
                  "HqsContributor"
                ],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DichVuChatLuongCao-detail",
              component: AdminDichVuChatLuongCaoForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "HqsManager",
                  "HqsContributor"
                ],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhGia",
          name: "Admin-DanhGia",
          redirect: "/admin/DanhGia/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhGia-list",
              component: AdminDanhGiaList,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourGuide",
                  "HqsManager",
                  "HqsContributor",
                  "VNATAdmin"
                ],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DanhGia-create",
              component: AdminDanhGiaForm,
              meta: {
                allowAccess: ["User"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DanhGia-update",
              component: AdminDanhGiaForm,
              meta: {
                allowAccess: ["User"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DanhGia-detail",
              component: AdminDanhGiaForm,
              meta: {
                allowAccess: [
                  "Admin",
                  "Officer",
                  "TourAgent",
                  "TourGuide",
                  "VNATAdmin"
                ],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "ThongBao",
          name: "Admin-ThongBao",
          redirect: "/admin/ThongBao/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-ThongBao-list",
              component: AdminThongBaoList,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent", "SVHTT"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-ThongBao-create",
              component: AdminThongBaoForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent", "SVHTT"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-ThongBao-update",
              component: AdminThongBaoForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent", "SVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-ThongBao-detail",
              component: AdminThongBaoForm,
              meta: {
                allowAccess: ["Admin", "Officer", "TourAgent", "SVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "CoSoLuuTru",
          name: "Admin-CoSoLuuTru",
          redirect: "/admin/CoSoLuuTru/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CoSoLuuTru-list",
              component: AdminCoSoLuuTruList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            // {
            //     path: 'create',
            //     name: 'Admin-CoSoLuuTru-create',
            //     component: AdminCoSoLuuTruForm,
            //     meta: {
            //         allowAccess: ['Admin'],
            //         page: 'admin'
            //     },
            // },
            // {
            //     path: 'update/:id',
            //     name: 'Admin-CoSoLuuTru-update',
            //     component: AdminCoSoLuuTruForm,
            //     meta: {
            //         allowAccess: ['Admin'],
            //         page: 'admin'
            //     },
            // },
            {
              path: "detail/:id",
              name: "Admin-CoSoLuuTru-detail",
              component: AdminCoSoLuuTruForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "CanhBaoHangNgay",
          name: "Admin-CanhBaoHangNgay",
          redirect: "/admin/CanhBaoHangNgay/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CanhBaoHangNgay-list",
              component: AdminCanhBaoHangNgayList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-CanhBaoHangNgay-create",
              component: AdminCanhBaoHangNgayForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-CanhBaoHangNgay-update",
              component: AdminCanhBaoHangNgayForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-CanhBaoHangNgay-detail",
              component: AdminCanhBaoHangNgayForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "ChuongTrinh",
          name: "Admin-ChuongTrinh",
          redirect: "/admin/ChuongTrinh/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-ChuongTrinh-list",
              component: AdminChuongTrinhList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-ChuongTrinh-create",
              component: AdminChuongTrinhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-ChuongTrinh-update",
              component: AdminChuongTrinhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-ChuongTrinh-detail",
              component: AdminChuongTrinhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DangKyChuongTrinh",
          name: "Admin-DangKyChuongTrinh",
          redirect: "/admin/DangKyChuongTrinh/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DangKyChuongTrinh-list",
              component: AdminDangKyChuongTrinhList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DangKyChuongTrinh-create",
              component: AdminDangKyChuongTrinhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DangKyChuongTrinh-update",
              component: AdminDangKyChuongTrinhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DangKyChuongTrinh-detail",
              component: AdminDangKyChuongTrinhForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "success",
              name: "Admin-DangKyChuongTrinh-success",
              component: AdminDangKyChuongTrinhListSuccess,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "ThanhTichHuyHieu",
          name: "Admin-ThanhTichHuyHieu",
          redirect: "/admin/ThanhTichHuyHieu/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-ThanhTichHuyHieu-list",
              component: AdminThanhTichHuyHieuList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-ThanhTichHuyHieu-create",
              component: AdminThanhTichHuyHieuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            // {
            //     path: 'update/:id',
            //     name: 'Admin-ThanhTichHuyHieu-update',
            //     component: AdminThanhTichHuyHieuForm,
            //     meta: {
            //         allowAccess: ['Admin', 'Officer'],
            //         page: 'admin'
            //     },
            // },
            {
              path: "detail/:id",
              name: "Admin-ThanhTichHuyHieu-detail",
              component: AdminThanhTichHuyHieuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "MsKhachDuLich",
          name: "Admin-MsKhachDuLich",
          redirect: "/admin/MsKhachDuLich/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-MsKhachDuLich-list",
              component: AdminMsKhachDuLichList,
              meta: {
                // allowAccess: ["Admin", "TourAgent"],
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-MsKhachDuLich-create",
              component: AdminMsKhachDuLichForm,
              meta: {
                // allowAccess: ["Admin", "TourAgent"],
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            // {
            //     path: 'update/:id',
            //     name: 'Admin-MsKhachDuLich-update',
            //     component: AdminMsKhachDuLichForm,
            //     meta: {
            //         allowAccess: ['Admin', 'Officer'],
            //         page: 'admin'
            //     },
            // },
            {
              path: "detail/:id",
              name: "Admin-MsKhachDuLich-detail",
              component: AdminMsKhachDuLichForm,
              meta: {
                // allowAccess: ["Admin", "TourAgent"],
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "register",
              name: "Admin-MsKhachDuLich-register",
              component: AdminMsKhachDuLichRegister,
              meta: {
                // allowAccess: ["Admin", "Officer", "TourAgent"],
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "PhienBan",
          name: "Admin-PhienBan",
          redirect: "/admin/PhienBan/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-PhienBan-list",
              component: AdminPhienBanList,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-PhienBan-create",
              component: AdminPhienBanForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-PhienBan-update",
              component: AdminPhienBanForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-PhienBan-detail",
              component: AdminPhienBanForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/NhomTPDanhGia",
          name: "Admin-NhomTPDanhGia",
          redirect: "/admin/DanhMuc/NhomTPDanhGia/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-NhomTPDanhGia-list",
              component: AdminNhomTPDanhGiaList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-NhomTPDanhGia-create",
              component: AdminNhomTPDanhGiaForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-NhomTPDanhGia-update",
              component: AdminNhomTPDanhGiaForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-NhomTPDanhGia-detail",
              component: AdminNhomTPDanhGiaForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/NhomPhanHoi",
          name: "Admin-NhomPhanHoi",
          redirect: "/admin/DanhMuc/NhomPhanHoi/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-NhomPhanHoi-list",
              component: AdminNhomPhanHoiList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-NhomPhanHoi-create",
              component: AdminNhomPhanHoiForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-NhomPhanHoi-update",
              component: AdminNhomPhanHoiForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-NhomPhanHoi-detail",
              component: AdminNhomPhanHoiForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/DanhMucTinTuc",
          name: "Admin-DanhMucTinTuc",
          redirect: "/admin/DanhMuc/DanhMucTinTuc/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhMucTinTuc-list",
              component: AdminDanhMucTinTucList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DanhMucTinTuc-create",
              component: AdminDanhMucTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DanhMucTinTuc-update",
              component: AdminDanhMucTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DanhMucTinTuc-detail",
              component: AdminDanhMucTinTucForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/QuocTich",
          name: "Admin-QuocTich",
          redirect: "/admin/DanhMuc/QuocTich/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-QuocTich-list",
              component: AdminQuocTichList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-QuocTich-create",
              component: AdminQuocTichForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-QuocTich-update",
              component: AdminQuocTichForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-QuocTich-detail",
              component: AdminQuocTichForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/NgoaiNgu",
          name: "Admin-NgoaiNgu",
          redirect: "/admin/DanhMuc/NgoaiNgu/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-NgoaiNgu-list",
              component: AdminNgoaiNguList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-NgoaiNgu-create",
              component: AdminNgoaiNguForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-NgoaiNgu-update",
              component: AdminNgoaiNguForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-NgoaiNgu-detail",
              component: AdminNgoaiNguForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/SoTruong",
          name: "Admin-SoTruong",
          redirect: "/admin/DanhMuc/SoTruong/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-SoTruong-list",
              component: AdminSoTruongList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-SoTruong-create",
              component: AdminSoTruongForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-SoTruong-update",
              component: AdminSoTruongForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-SoTruong-detail",
              component: AdminSoTruongForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/HuyHieu",
          name: "Admin-HuyHieu",
          redirect: "/admin/DanhMuc/HuyHieu/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-HuyHieu-list",
              component: AdminHuyHieuList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-HuyHieu-create",
              component: AdminHuyHieuForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-HuyHieu-update",
              component: AdminHuyHieuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-HuyHieu-detail",
              component: AdminHuyHieuForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/CauHinh",
          name: "Admin-CauHinh",
          redirect: "/admin/DanhMuc/CauHinh/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CauHinh-list",
              component: AdminCauHinhList,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-CauHinh-create",
              component: AdminCauHinhForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-CauHinh-update",
              component: AdminCauHinhForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-CauHinh-detail",
              component: AdminCauHinhForm,
              meta: {
                allowAccess: ["Admin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhMuc/NguoiDung",
          name: "Admin-NguoiDung",
          redirect: "/admin/DanhMuc/NguoiDung/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-NguoiDung-list",
              component: AdminNguoiDungList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-NguoiDung-create",
              component: AdminNguoiDungForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-NguoiDung-update",
              component: AdminNguoiDungForm,
              meta: {
                allowAccess: ["*"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-NguoiDung-detail",
              component: AdminNguoiDungForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "NguoiDungTcqltt",
          name: "Admin-NguoiDungTcqltt",
          redirect: "/admin/NguoiDungTcqltt/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-NguoiDungTcqltt-list",
              component: AdminNguoiDungTcqlttList,
              meta: {
                allowAccess: ["TCQLTTP"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-NguoiDungTcqltt-create",
              component: AdminNguoiDungTcqlttForm,
              meta: {
                allowAccess: ["TCQLTTP"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-NguoiDungTcqltt-update",
              component: AdminNguoiDungTcqlttForm,
              meta: {
                allowAccess: ["TCQLTTP"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-NguoiDungTcqltt-detail",
              component: AdminNguoiDungTcqlttForm,
              meta: {
                allowAccess: ["TCQLTTP"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DiemDenAnToan",
          name: "Admin-DiemDenAnToan",
          redirect: "/admin/DiemDenAnToan/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DiemDenAnToan-list",
              component: AdminDiemDenAnToanList,
              meta: {
                allowAccess: ["Admin", "Officer", "VNATAdmin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DiemDenAnToan-update",
              component: AdminDiemDenAnToanSurveyForm,
              meta: {
                allowAccess: ["Admin", "Officer", "VNATAdmin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DiemDenAnToan-detail",
              component: AdminDiemDenAnToanForm,
              meta: {
                allowAccess: ["Admin", "Officer", "VNATAdmin"],
                page: "admin"
              }
            },
            {
              path: "import",
              name: "Admin-DiemDenAnToan-import",
              component: AdminDiemDenAnToanImport,
              meta: {
                allowAccess: [
                  "Admin",
                  "SafePlace",
                  "SafePlaceManager",
                  "VNATAdmin"
                ],
                page: "admin"
              }
            },
            {
              path: "success",
              name: "Admin-DiemDenAnToan-success",
              component: AdminDiemDenAnToanUpdateSuccess,
              meta: {
                allowAccess: ["Admin", "Officer", "VNATAdmin"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DangKyDDAT",
          name: "Admin-DangKyDDAT",
          redirect: "/admin/DangKyDDAT/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DangKyDDAT-list",
              component: AdminDangKyDDATList,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin"
              }
            },
            {
              path: "success",
              name: "Admin-DangKyDDAT-success",
              component: AdminDangKyDDATListSuccess,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DangKyDDAT-create",
              component: AdminDangKyDDATForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DangKyDDAT-update",
              component: AdminDangKyDDATForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DangKyDDAT-detail",
              component: AdminDangKyDDATForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin"
              }
            },
            {
              path: "daily/:id",
              name: "Admin-DangKyDDAT-daily",
              component: AdminDangKyDDATForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin"
              }
            }
          ]
        },
        // {
        //   path: "/admin/DanhGiaDDATHangNgay/daily",
        //   name: "Admin-DanhGiaDDATHangNgay-daily",
        //   component: DanhGiaDDATHangNgay,
        //   meta: {
        //     allowAccess: ["SafePlace"],
        //     page: "admin"
        //   }
        // },
        {
          path: "CheckinDDAT",
          name: "Admin-CheckinDDAT",
          redirect: "/admin/CheckinDDAT/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CheckinDDAT-list",
              component: AdminCheckinDDATList,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-CheckinDDAT-create",
              component: AdminCheckinDDATForm,
              meta: {
                allowAccess: ["SafePlace"],
                page: "admin"
              }
            },
            // {
            //     path: 'update/:id',
            //     name: 'Admin-CheckinDDAT-update',
            //     component: AdminCheckinDDATForm,
            //     meta: {
            //         allowAccess: ['Admin', 'Officer','SafePlace'],
            //         page: 'admin'
            //     },
            // },
            {
              path: "detail/:id",
              name: "Admin-CheckinDDAT-detail",
              component: AdminCheckinDDATForm,
              meta: {
                allowAccess: ["Admin", "Officer", "SafePlace"],
                page: "admin"
              }
            }
          ]
        },
        // {
        //   path: "VungDich",
        //   name: "Admin-VungDich",
        //   redirect: "/admin/VungDich/list",
        //   component: {
        //     render(c) {
        //       return c("router-view");
        //     }
        //   },
        //   children: [
        //     {
        //       path: "list",
        //       name: "Admin-VungDich-list",
        //       component: AdminVungDichList,
        //       meta: {
        //         allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
        //         page: "admin"
        //       }
        //     },
        //     {
        //       path: "create",
        //       name: "Admin-VungDich-create",
        //       component: AdminVungDichForm,
        //       meta: {
        //         allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
        //         page: "admin"
        //       }
        //     },
        //     {
        //       path: "update/:id",
        //       name: "Admin-VungDich-update",
        //       component: AdminVungDichForm,
        //       meta: {
        //         allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
        //         page: "admin"
        //       }
        //     },
        //     {
        //       path: "detail/:id",
        //       name: "Admin-VungDich-detail",
        //       component: AdminVungDichForm,
        //       meta: {
        //         allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
        //         page: "admin"
        //       }
        //     }
        //   ]
        // },
        {
          path: "DanhGiaKDL",
          name: "Admin-DanhGiaKDL",
          redirect: "/admin/DanhGiaKDL/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhGiaKDL-list",
              component: AdminDanhGiaKDLList,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DanhGiaKDL-create",
              component: AdminDanhGiaKDLForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DanhGiaKDL-update",
              component: AdminDanhGiaKDLForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DanhGiaKDL-detail",
              component: AdminDanhGiaKDLForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhGiaDDAT",
          name: "Admin-DanhGiaDDAT",
          redirect: "/admin/DanhGiaDDAT/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhGiaDDAT-list",
              component: AdminDanhGiaDDATList,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DanhGiaDDAT-create",
              component: AdminDanhGiaDDATForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DanhGiaDDAT-update",
              component: AdminDanhGiaDDATForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DanhGiaDDAT-detail",
              component: AdminDanhGiaDDATForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhGiaDDATDetail",
          name: "Admin-DanhGiaDDATDetail",
          redirect: "/admin/DanhGiaDDATDetail/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhGiaDDATDetail-list",
              component: AdminDanhGiaDDATDetailList,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DanhGiaDDATDetail-create",
              component: AdminDanhGiaDDATDetailForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DanhGiaDDATDetail-update",
              component: AdminDanhGiaDDATDetailForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DanhGiaDDATDetail-detail",
              component: AdminDanhGiaDDATDetailForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DanhGiaKDLDetail",
          name: "Admin-DanhGiaKDLDetail",
          redirect: "/admin/DanhGiaKDLDetail/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DanhGiaKDLDetail-list",
              component: AdminDanhGiaKDLDetailList,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-DanhGiaKDLDetail-create",
              component: AdminDanhGiaKDLDetailForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-DanhGiaKDLDetail-update",
              component: AdminDanhGiaKDLDetailForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DanhGiaKDLDetail-detail",
              component: AdminDanhGiaKDLDetailForm,
              meta: {
                allowAccess: ["Admin", "VNATAdmin", "SVHTT", "PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "TruyVanSMS",
          name: "Admin-TruyVanSMS",
          component: AdminTruyVanSMSForm,
          meta: {
            allowAccess: ["Officer"],
            page: "admin"
          }
        },
        {
          path: "QuangCao",
          name: "Admin-QuangCao",
          redirect: "/admin/QuangCao/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-QuangCao-list",
              component: AdminQuangCaoList,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "create",
              name: "Admin-QuangCao-create",
              component: AdminQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "update/:id",
              name: "Admin-QuangCao-update",
              component: AdminQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-QuangCao-detail",
              component: AdminQuangCaoForm,
              meta: {
                allowAccess: ["Admin", "Officer"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "HDSD",
          name: "Admin-HSDS",
          component: AdminHDSD,
          meta: {
            allowAccess: ["Officer"],
            page: "admin"
          }
        },
        {
          path: "TrangDieuHanh",
          name: "Admin-TrangDieuHanh",
          component: TrangDieuHanh,
          meta: {
            allowAccess: ["SVHTT"],
            page: "admin"
          }
        },
        {
          path: "DoanhNghiepLuHanh",
          name: "Admin-DoanhNghiepLuHanh",
          redirect: "/admin/DoanhNghiepLuHanh/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DoanhNghiepLuHanh-list",
              component: AdminDiemDenAnToanList,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DoanhNghiepLuHanh-detail",
              component: AdminDiemDenAnToanForm,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "CoSoLuuTruVHTT",
          name: "Admin-CoSoLuuTruVHTT",
          redirect: "/admin/CoSoLuuTruVHTT/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-CoSoLuuTruVHTT-list",
              component: AdminDiemDenAnToanList,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-CoSoLuuTruVHTT-detail",
              component: AdminDiemDenAnToanForm,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DiemDen",
          name: "Admin-DiemDen",
          redirect: "/admin/DiemDen/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DiemDen-list",
              component: AdminDiemDenAnToanList,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DiemDen-detail",
              component: AdminDiemDenAnToanForm,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "DiemMuaSam",
          name: "Admin-DiemMuaSam",
          redirect: "/admin/DiemMuaSam/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-DiemMuaSam-list",
              component: AdminDiemDenAnToanList,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-DiemMuaSam-detail",
              component: AdminDiemDenAnToanForm,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "NhaHangDuLich",
          name: "Admin-NhaHangDuLich",
          redirect: "/admin/NhaHangDuLich/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-NhaHangDuLich-list",
              component: AdminDiemDenAnToanList,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-NhaHangDuLich-detail",
              component: AdminDiemDenAnToanForm,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: "VanTai",
          name: "Admin-VanTai",
          redirect: "/admin/VanTai/list",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "list",
              name: "Admin-VanTai-list",
              component: AdminDiemDenAnToanList,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            },
            {
              path: "detail/:id",
              name: "Admin-VanTai-detail",
              component: AdminDiemDenAnToanForm,
              meta: {
                allowAccess: ["SVHTT","PVHTT"],
                page: "admin"
              }
            }
          ]
        },
        {
          path: 'Merchant',
          name: 'Admin-Merchant',
          redirect: '/admin/Merchant/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: 'list',
            name: 'Admin-Merchant-list',
            component: AdminQuanLyMerchantList,
            meta: {
              allowAccess: ["Admin", "Officer"],
              page: 'admin'
            },
          },
          {
            path: 'update/:id',
            name: 'Admin-Merchant-update',
            component: AdminQuanLyMerchantForm,
            meta: {
              allowAccess: ["Admin", "Officer"],
              page: 'admin'
            },
          },
          {
            path: 'detail/:id',
            name: 'Admin-Merchant-detail',
            component: AdminQuanLyMerchantForm,
            meta: {
              allowAccess: ["Admin", "Officer"],
              page: 'admin'
            },
          },
          ]
        },
        {
          path: 'LienKetNganHangSHB',
          name: 'Admin-LienKetNganHangSHB',
          redirect: '/admin/LienKetNganHangSHB/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: 'list',
            name: 'Admin-LienKetNganHangSHB-list',
            component: AdminLienKetNganHangSHBList,
            meta: {
              allowAccess: ["Admin", "Officer"],
              page: 'admin'
            },
          },
          {
            path: 'update/:id',
            name: 'Admin-LienKetNganHangSHB-update',
            component: AdminLienKetNganHangSHBForm,
            meta: {
              allowAccess: ["Admin", "Officer"],
              page: 'admin'
            },
          },
          {
            path: 'detail/:id',
            name: 'Admin-LienKetNganHangSHB-detail',
            component: AdminLienKetNganHangSHBForm,
            meta: {
              allowAccess: ["Admin", "Officer"],
              page: 'admin'
            },
          },
          {
            path: 'chua-lien-ket',
            name: 'Admin-LienKetNganHangSHB-chualienket',
            component: AdminLienKetNganHangSHBChuaLienKetList,
            meta: {
              allowAccess: ["Admin", "Officer"],
              page: 'admin'
            },
          },
          ]
        }
      ]
    },
    {
      path: "/dangky",
      name: "Auth-RegisterSafePlaceUser",
      component: AuthRegisterSafePlaceUser,
      meta: {
        page: "auth"
      }
    },
    {
          path: '/merchant-test',
          name: 'MerchantTest',
          component: MerchantTest,
          meta: {
            allowAccess: ["*"],
            page: 'client'
          },
        },
    {
      path: "/auth",
      redirect: "/auth/login",
      name: "Auth",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      beforeEnter: (to, from, next) => {
        clearInterval(window.reqIntervalPhanHoi);
        next();
      },
      children: [
        {
          path: "404",
          name: "Auth-Page404",
          component: AuthPage404,
          meta: {
            page: "auth"
          }
        },
        {
          path: "login",
          name: "Auth-Login",
          component: AuthLogin,
          meta: {
            page: "auth"
          }
        },
        {
          path: "register",
          name: "Auth-Register",
          component: AuthRegister,
          meta: {
            page: "auth"
          }
        },
        {
          path: "changepassword",
          name: "Auth-ChangePassword",
          component: AuthChangePassword,
          meta: {
            allowAccess: ["*"],
            page: "admin"
          }
        },
        {
          path: "forgotPassword",
          name: "Auth-ForgotPassword",
          component: AuthForgotPassword,
          meta: {
            page: "auth"
          }
        },
        {
          path: "resetPassword",
          name: "Auth-ResetPassword",
          component: AuthResetPassword,
          meta: {
            page: "auth"
          }
        }
      ]
    },
    {
      path: "/dashboard",
      name: "Client-Dashboard",
      component: ClientDashboard,
      meta: {
        page: "client"
      }
    }
  ]
});
export default router;

//check route
router.beforeEach(function(to, from, next) {
  // debugger
  if (from.name != to.name) {
    if (to.meta.page && to.meta.page == "admin") {
      AuthService.me()
        .then(res => {
          if (
            res.result &&
            res.result.account === "tcqltt" &&
            res.result.roles.includes("TCQLTT")
          ) {
            res.result.roles.push("TCQLTTP");
          }
          window.localStorage.setItem(
            "currentUser",
            JSON.stringify(res.result)
          );

          LanguageService.lang = res.result.roles.includes("Foreigner") ? LanguageService.en : LanguageService.vi;

          if (to.meta.allowAccess && to.meta.allowAccess.indexOf("*") == 0) {
            next();
          } else if (
            to.meta.allowAccess &&
            to.meta.allowAccess.indexOf("SafePlace") == 0
          ) {
            if (MethodService.checkRole("SafePlace")) {
              next();
            } else {
              next("/auth/registerSafePlaceUser");
            }
          } else {
            if (res.result && res.result.roles && res.result.roles.length > 0) {
              var access = false;
              res.result.roles.forEach(item => {
                if (
                  to.meta.allowAccess &&
                  to.meta.allowAccess.indexOf(item) != -1
                ) {
                  access = true;
                }
              });
              if (access) {
                next();
              } else {
                toastr.warning("Không có quyền truy cập trang này");
              }
            }
          }
        })
        .catch(error => {
          if (
            to.meta.allowAccess &&
            to.meta.allowAccess.indexOf("SafePlace") == 0
          ) {
            next("/auth/registerSafePlaceUser");
          } else {
            window.localStorage.removeItem("currentUser");
            next("/auth/login");
          }
        });
    } else if (to.meta.page && to.meta.page != "admin") {
      next();
    } else {
      next("/auth/404");
    }
  } else {
    if (!to.name) {
      next("/auth/404");
    } else {
      next();
    }
  }
});
